import { Navigate, Outlet } from 'react-router';
import { useAuth } from '../lib/auth-context';
import { useAuthOrigin } from '../lib/auth-origin';
import { PageSpinner } from '../components/ui/spinner';
import { useLocale } from '../i18n/locale-context';
import { localePath } from '../i18n/locale-path';

export function Protected() {
  const { status } = useAuth();
  const { locale } = useLocale();
  // The cabinet page the guest asked for (`/uz/app/alerts?…`) — read before the
  // early returns below, as a hook must be.
  const authOrigin = useAuthOrigin();

  if (status === 'loading') {
    return <PageSpinner />;
  }

  if (status === 'guest') {
    // Hand the page over to /login, which returns there after the sign-in
    // (`usePostAuthNext` → `postAuthPath`, validated by `isSafeNextPath`). Without
    // it, a guest who tapped «Открыть в кабинете» in an alert letter or a digest
    // link signed in and landed on the catalogue instead (QA 2026-10-22).
    //
    // History `state`, like every other in-app entry point (`useAuthOrigin`), not
    // `?next=`: the destination stays out of the address bar, the access log and
    // the pixels' page URL. It is always this app's own pathname + search — never
    // an absolute URL — and the hash is dropped.
    return <Navigate to={localePath('/login', locale)} state={authOrigin} replace />;
  }

  return <Outlet />;
}
